import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { User } from '../models/user';

@Injectable()
export class UserService {
	public user = new User();
	public user$: BehaviorSubject<any>;

	constructor(private _http: HttpClient) {
		this.user$ = new BehaviorSubject(this.user);
	}

	/**
	 * @api {put} /v2/Authentication/InetUser/Password Change Password
	 * @apiName changePassword
	 * @apiGroup Authentication
	 * @apiVersion 20.0.0
	 */
	changePassword(data) {
		return this._http.put<any>(`${environment.apiUrl}/v2/Authentication/InetUser/Password`, data);
	}

	deleteUser() {
		this.user = new User();
		localStorage.removeItem('Rapidship:user');
		this.user$.next(this.user);
	}

	/**
	 * @api {get} /v2/InetUsers/MiscData Get Inet Users Miscellaneous Data
	 * @apiName getInetUserMiscData
	 * @apiGroup InetUsers
	 * @apiVersion 20.0.0
	 */
	getInetUserMiscData() {
		return this._http.get<any>(`${environment.apiUrl}/v2/InetUsers/MiscData`);
	}

	getUser() {
		const user = JSON.parse(localStorage.getItem('Rapidship:user'));
		if (user && (!this.user || (this.user && !this.user.token))) {
			this.user$.next(user);
		}
		this.user = user;
		return this.user;
	}

	/**
	 * @api {post} /v2/Authentication/Reset Change Password
	 * @apiName reset
	 * @apiGroup InetUsers
	 * @apiVersion 20.1.0
	 */
	reset(data) {
		return this._http.post<any>(`${environment.apiUrl}/v2/Authentication/Reset`, data);
	}

	/**
	 * @api {post} /v2/Authentication/ResetPassword Request Reset Password Link Via Email
	 * @apiName resetPassword
	 * @apiGroup Authentication
	 * @apiVersion 20.1.0
	 */
	resetPassword(emailAddress) {
		return this._http.post<any>(`${environment.apiUrl}/v2/Authentication/ResetPassword`, {emailAddress, userType: 'Inet'});
	}

	/**
	 * @api {put} /v2/InetUsers/MiscData Update Inet Users Miscellaneous Data
	 * @apiName setInetUserMiscData
	 * @apiGroup InetUsers
	 * @apiVersion 20.0.0
	 */
	setInetUserMiscData(data) {
		return this._http.put<any>(`${environment.apiUrl}/v2/InetUsers/MiscData`, data);
	}

	updateUser(user) {
		let userUpdate;
		const storedUser = JSON.parse(localStorage.getItem('Rapidship:user'));
		if (storedUser) {
			userUpdate = Object.assign(storedUser, user);
		} else {
			userUpdate = user;
		}
		localStorage.setItem('Rapidship:user', JSON.stringify(userUpdate));
		this.user = userUpdate;
		this.user$.next(this.user);
	}

	/**
	 * @api {patch} /v2/InetUsers Update User Profile
	 * @apiName updateUserProfile
	 * @apiGroup InetUsers
	 * @apiVersion 20.0.0
	 */
	updateUserProfile(data) {
		return this._http.patch<any>(`${environment.apiUrl}/v2/InetUsers`, data);
	}
}
